import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ChevronRight, FileCheck2, ShieldCheck } from "lucide-react";
import { assetUrl } from "@/lib/api";

const BALLOT_LABELS = {
  supports: "Supports paper ballots",
  not_stated: null,
  custom: "Position stated",
};

export const CandidateCard = ({ candidate, declareMode = false }) => {
  const initials = candidate.public_name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");
  const ballotLabel = BALLOT_LABELS[candidate.paper_ballot_position];
  return (
    <Card
      className="hover:shadow-md hover:border-slate-300 transition-shadow duration-150"
      data-testid={`candidate-card-${candidate.slug}`}
    >
      <CardContent className="p-5">
        <div className="flex items-start gap-4">
          {candidate.photo ? (
            <img
              src={assetUrl(candidate.photo)}
              alt={candidate.public_name}
              className="h-16 w-16 rounded-lg object-cover border border-slate-200"
            />
          ) : (
            <div className="h-16 w-16 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center text-lg font-semibold text-slate-500 font-heading">
              {initials}
            </div>
          )}
          <div className="min-w-0 flex-1">
            <h3 className="font-heading font-semibold text-base text-foreground truncate">
              {candidate.public_name}
            </h3>
            <p className="text-sm text-muted-foreground mt-0.5">{candidate.office.label}</p>
            <p className="text-xs text-muted-foreground">
              {candidate.municipality.name} · {candidate.election.election_year}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-4 flex-wrap">
          {ballotLabel && (
            <Badge variant="outline" className="bg-emerald-50 text-emerald-800 border-emerald-200 text-xs">
              <FileCheck2 className="h-3 w-3 mr-1" /> {ballotLabel}
            </Badge>
          )}
          {candidate.office.ward_label && (
            <Badge variant="outline" className="text-xs">
              {candidate.office.ward_label}
            </Badge>
          )}
        </div>
        <div className="flex items-center justify-between mt-4">
          <Link
            to={candidate.path}
            data-testid={`candidate-view-profile-${candidate.slug}`}
            className="inline-flex items-center text-sm font-semibold text-primary hover:underline"
          >
            View profile <ChevronRight className="h-4 w-4 ml-0.5" />
          </Link>
          {declareMode && (
            <Button asChild size="sm" data-testid={`candidate-declare-${candidate.slug}`}>
              <Link to={`${candidate.path}/declare`}>
                <ShieldCheck className="h-4 w-4 mr-1.5" /> Witness My Vote
              </Link>
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
